import { FC, useContext, useState } from 'react';
import {
  Dialog,
  Flex,
  Button,
  ButtonGroup,
  Input,
  Textarea,
  Checkbox,
  InputChips,
} from '@/_components';
import { DropLinksContext } from '../../DropLinksProvider';
import type { CreateDropLinkDialogProps } from './CreateDropLinkDialog.types';

export const CreateDropLinkDialog: FC<CreateDropLinkDialogProps> = ({
  isOpen,
  onClose,
}) => {
  const {
    newDropLinkName,
    setNewDropLinkName,
    newDropLinkHideSignIn,
    setNewDropLinkHideSignIn,
    newDropLinkUserIds,
    setNewDropLinkUserIds,
    newDropLinkCustomInstruction,
    setNewDropLinkCustomInstruction,
    firmUserOptions,
    handleCreateDropLink,
    isLoading,
  } = useContext(DropLinksContext);

  const [chipToAddInputText, setChipToAddInputText] = useState('');

  const handleCreateDropLinkChipsChange = (
    event: React.ChangeEvent<HTMLInputElement>,
  ) => {
    setChipToAddInputText(event.target.value);
  };

  const handleCreateDropLinkSetChips = (
    chips: Set<string> | ((_prev: Set<string>) => Set<string>),
  ) => {
    const newChips =
      typeof chips === 'function' ? chips(newDropLinkUserIds) : chips;
    setNewDropLinkUserIds(newChips);
  };

  const handleSubmit = async () => {
    await handleCreateDropLink();
    onClose();
  };

  return (
    <Dialog isOpen={isOpen} onClose={onClose} title="Create Drop Link">
      <Dialog.Content>
        <Flex gap={10} isColumn={true}>
          <Input
            label="Name"
            placeholder="Enter drop link name (visible to clients)"
            value={newDropLinkName}
            onChange={(e) => setNewDropLinkName(e.target.value)}
            isRequired={true}
          />
          <Textarea
            label="Custom Instruction"
            placeholder="Enter custom instruction (optional)"
            value={newDropLinkCustomInstruction}
            onChange={(e) => setNewDropLinkCustomInstruction(e.target.value)}
            rows={4}
          />
          <Checkbox
            label="Hide Sign In Button"
            isChecked={newDropLinkHideSignIn}
            onChange={(e) => setNewDropLinkHideSignIn(e.target.checked)}
          />
          <InputChips
            label="Notify Users"
            placeholder="Select users to notify"
            isRequired={true}
            chips={newDropLinkUserIds}
            setChips={handleCreateDropLinkSetChips}
            onChange={handleCreateDropLinkChipsChange}
            value={chipToAddInputText}
            results={firmUserOptions}
            chipNames={firmUserOptions}
          />
          <ButtonGroup align="right">
            <Button intent="secondary" value="Cancel" onClick={onClose} />
            <Button
              intent="primary"
              value="Create"
              onClick={handleSubmit}
              isDisabled={
                !newDropLinkName || newDropLinkUserIds.size === 0 || isLoading
              }
            />
          </ButtonGroup>
        </Flex>
      </Dialog.Content>
    </Dialog>
  );
};
